import { ApiError } from '../../types';

export class SurveyFormFetchingError extends ApiError {
  constructor(...args: ConstructorParameters<typeof ApiError>) {
    super(...args);
  }
}

export class SurveyFormFetchingCodeError extends SurveyFormFetchingError {
  constructor(...args: ConstructorParameters<typeof ApiError>) {
    super(...args);
  }
}

export class IncorrectDataError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class UserNotConfirmedError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class SurveyAlreadyCompletedError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class UserExcludedByPolicyError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class SurveyNotFoundError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class UserNotFoundError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class TechnicalError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class EpkCmPairError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class OtherError extends SurveyFormFetchingCodeError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingCodeError>) {
    super(...args);
  }
}

export class UnknownServerMessageError extends SurveyFormFetchingError {
  constructor(...args: ConstructorParameters<typeof SurveyFormFetchingError>) {
    super(...args);
  }
}
